import {
  defineSchema,
  SchemaInstance,
} from "@redotech/redo-flows-core-schema-common/type-system/schema";

/**
 * Fake (like baseCheckoutTreeSchema): the questionnaire lives on CRDB
 * hsa_questionnaire_flow, not AdvancedFlow; needed for the editor type system.
 */
export const baseHsaQuestionnaireSchema = defineSchema({ fields: {} });

export const exampleBaseHsaQuestionnaireInstance: SchemaInstance<
  typeof baseHsaQuestionnaireSchema
> = {};
